import { abWrapPageElement } from './abWrapPageElement';
import { abWrapRootElement } from './abWrapRootElement';
import { applyMachineTranslateFix } from '@ab-core/abds-provider/utils';

// Patches Node.prototype.removeChild/insertBefore to prevent React crashes
// caused by external DOM modifications (browser translators, extensions, etc.)
applyMachineTranslateFix();

export const wrapPageElement = abWrapPageElement;

export const wrapRootElement = abWrapRootElement;
